import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import mensajes from "src/assets/constantes/mensajes.json";

import { ModalTitles, ModalType } from "@shared/Constantes/modal.constantes";
import { NotificationRequest } from "@shared/Interfaces/Notificaciones/notification-request.interface";
import { ModalService } from "@shared/Services/modal.service";
import { NotificationService } from "@shared/Services/notification.service";

@Component({
  selector: "app-notificaciones",
  templateUrl: "./notificaciones.component.html",
})
export class NotificacionesComponent implements OnInit {
  public massiveNotification: boolean = false;
  public currentDate = new Date();
  public minDate: string;
  public maxDate: string;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private modalService: ModalService,
    private notificationService: NotificationService
  ) {}

  public form: FormGroup;

  public ngOnInit(): void {
    this.minDate = new Date().toISOString().slice(0, 16);
    this.currentDate.setDate(this.currentDate.getDate() + 6);
    this.maxDate = this.currentDate.toISOString().slice(0, 16);

    this.form = this.formBuilder.group({
      mensaje: ["", Validators.required],
      cta: ["", Validators.required],
      link: ["", [Validators.required, Validators.pattern("(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?")]],
      email: ["", [Validators.required, Validators.email]],
      date: [""],
      checkbox: [false],
    });
    this.form.get("date").disable();
  }

  public onSubmit(): void {
    const notification: NotificationRequest = {
      title: "Universal Hola",
      message: `${this.form.value.mensaje}\n\n`,
      cta: this.form.value.cta,
      link: this.form.value.link,
      type: 2,
      date: new Date(this.form.value.date),
      isMassive: this.massiveNotification,
      user: this.form.value.email,
    };

    if (new Date(this.form.value.date) < new Date()) {
      this.modalService.showModalGeneral({
        title: ModalTitles.danger,
        body: mensajes.formularioNotificaciones.invalidDate.body,
        type: ModalType.danger,
      });
      return;
    }

    this.modalService
      .showConfirm({
        title: ModalTitles.warning,
        body: `¿Está seguro de que desea enviar esta notificación ${this.massiveNotification ? "masiva" : "de prueba"}?`,
        type: ModalType.warning,
      })
      .subscribe((sendNotification) => {
        if (sendNotification) {
          this.notificationService.sendNotification(notification).subscribe({
            next: () => {
              this.modalService.showModalGeneral({
                title: ModalTitles.success,
                body: mensajes.general.success,
                type: ModalType.success,
              });
            },
            error: () => {
              this.modalService.showModalGeneral({
                title: ModalTitles.danger,
                body: mensajes.general.error,
                type: ModalType.danger,
              });
            },
          });
        }
      });
  }

  public onCancel(): void {
    this.modalService
      .showConfirm({
        title: ModalTitles.warning,
        body: mensajes.formularioNotificaciones.resetForm.body,
        type: ModalType.warning,
      })
      .subscribe((cancelled) => {
        if (cancelled) {
          this.form.reset();
          this.form.get("date").disable();
          this.form.get("email").addValidators(Validators.required);
        }
      });
  }

  public toggleTestNotification(): void {
    this.massiveNotification = !this.massiveNotification;
    const dateControl = this.form.get("date");
    const emailControl = this.form.get("email");

    dateControl.reset();
    emailControl.reset();

    if (!this.massiveNotification) {
      dateControl.disable();
      emailControl.addValidators(Validators.required);
      emailControl.updateValueAndValidity();
      dateControl.removeValidators(Validators.required);
      dateControl.updateValueAndValidity();
    } else {
      dateControl.enable();
      emailControl.removeValidators(Validators.required);
      emailControl.updateValueAndValidity();
      dateControl.addValidators(Validators.required);
      dateControl.updateValueAndValidity();
    }
  }
}
